import React from 'react'
import PropTypes from 'prop-types'
import firebase from 'firebase'
import update from 'react-addons-update'
// import AlertContainer from 'react-alert'
import { locale, polyglot, dataAppDatabase } from '../../../index'
import { takeCanvasScreenshot } from '../../../resources/utilities'
import ConsultationsTable from './ConsultationsTable/ConsultationsTable'
import TeethEruption from './TeethEruption/TeethEruption'
import FinalConsultation from './FinalConsultation/FinalConsultation'
import Loading from '../../common/Loading/Loading'
import TabsContainer from '../../common/TabsContainer/TabsContainer'

export default class Age extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      age: undefined,
      patientKey: undefined,
      patient: undefined,
      currentPatientData: undefined,
      loading: '',
      config: undefined,
      availableTeeth: undefined,
      openedTab: 0
    }
    this.handleChangeConsults = this.handleChangeConsults.bind(this)
    this.handleChangeTeethEruption = this.handleChangeTeethEruption.bind(this)
    this.handleChangeFinalConsultation = this.handleChangeFinalConsultation.bind(this)
    this.getContentForTabsContainer = this.getContentForTabsContainer.bind(this)
  }

  getPatient (patientNumber) {
    const rootRef = dataAppDatabase.ref()
    const patientRef = rootRef.child('riso').child('patientsByCountry').child(locale)
    patientRef.on('value', snapshot => {
      snapshot.forEach((childSnap) => {
        if (childSnap.val().patientNumber.toString() === patientNumber) {
          const patient = childSnap.val()
          const patientKey = childSnap.key
          this.props.setPatientId(patient.patientNumber)
          if (patient) {
            this.setState({
              patientKey: patientKey,
              currentPatientBirthDate: patient.birthDate
            })
          }
          if (patient.data && patient.data.ages) {
            this.setState({
              currentPatientData: patient.data.ages[this.state.age]
            })
          }
          if (patient.data) {
            this.setState({
              currentPatientTeethStatus: patient.data.teethStatus
            })
          }
        }
      })
    })
  }

  getConfigurationForAge (ageValue) {
    const rootRef = firebase.database().ref()
    const config = rootRef.child('riso').child('configuration')
    config.on('value', dataSnapshot => {
      dataSnapshot.child('ages').forEach(ageSnapshot => {
        const ageStart = ageSnapshot.child('ageInterval').child('start').val()
        if (ageStart === Number(ageValue)) {
          const availableTeeth = ageSnapshot.child('elements').child('availableTeeth').val()
          this.setState({
            config: ageSnapshot.child('elements').val(),
            availableTeeth: availableTeeth,
            teethData: dataSnapshot.child('teethData').val()
          })
        }
      })
    })
  }

  componentWillMount () {
    const age = this.props.location.search.replace('?id=', '')
    this.setState({
      age: age
    }, function () {
      this.getPatient(this.props.match.params.patientId)
      this.getConfigurationForAge(age)
    })
  }

  getCurrentAgePatientData (patientNumber, age) {
    const rootRef = dataAppDatabase.ref()
    const patientRef = rootRef.child('riso').child('patientsByCountry').child(locale)
    let patientData = null
    patientRef.on('value', snapshot => {
      snapshot.forEach((childSnap) => {
        if (childSnap.val().patientNumber.toString() === patientNumber) {
          patientData = childSnap.val().data
          if (patientData && patientData.ages) {
            this.setState({
              currentPatientData: patientData.ages[age]
            })
          }
        }
      })
    })
  }

  componentWillReceiveProps (props) {
    const age = props.location.search.replace('?id=', '')
    if (this.state.age !== age) {
      this.setState({
        openedTab: 0
      })
    }
    this.setState({
      age: age,
      currentPatientData: null
    }, function () {
      this.getConfigurationForAge(age)
      this.getCurrentAgePatientData(props.match.params.patientId, age)
    })
  }

  componentWillUpdate (nextProps, nextState) {
    if (this.state.age !== nextState.age) {
      this.getConfigurationForAge(nextState.age)
      this.getCurrentAgePatientData(this.props.match.params.patientId, nextState.age)
    }
    if (nextState.currentPatientData && nextState.currentPatientData.eruption && nextState.currentPatientData.eruption.eruptionDates) {
      nextState.currentPatientData = update(nextState.currentPatientData, {
        eruption: {eruptionDates: {$set: this.sortEruptions(nextState.currentPatientData.eruption.eruptionDates)}}
      })
    }
  }

  sortEruptions (eruptions) {
    return eruptions.sort(function (a, b) { return new Date(a.date).getTime() - new Date(b.date).getTime() })
  }

  handleChangeConsults (consultation) {
    const rootRef = dataAppDatabase.ref()
    const consultsDataRef = rootRef.child('riso').child('patientsByCountry').child(locale).child(this.state.patientKey).child('data').child('ages').child(this.state.age).child('consultations')
    consultsDataRef.push(consultation)
  }

  handleChangeTeethEruption (data, key) {
    const rootRef = dataAppDatabase.ref()
    const eruptionDataRef = rootRef.child('riso').child('patientsByCountry').child(locale).child(this.state.patientKey).child('data').child('ages').child(this.state.age)
      .child('eruption').child(key)
    eruptionDataRef.set(data)
  }

  handleChangeFinalConsultation (consultation) {
    this.setState({
      loading: 'cursor-loading'
    })
    const rootRef = dataAppDatabase.ref()
    const consultationDataRef = rootRef.child('riso').child('patientsByCountry').child(locale).child(this.state.patientKey).child('data').child('ages').child(this.state.age).child('finalConsultationData')
    const canvasData = takeCanvasScreenshot()
    consultationDataRef.child('teethScreenshot').set(canvasData)
    consultationDataRef.update(consultation).then(() => {
      this.setState({
        loading: ''
      })
      // this.msg.success(polyglot.t('staticText.consultationSuccessfullyUpdated'))
    })
  }

  getContentForTabsContainer () {
    const content = []
    content.push()
    if (this.state.config) {
      content.push({
        label: polyglot.t('staticText.otherConsultations'),
        content: <ConsultationsTable config={this.state.config.simpleConsultationInsertion} key={`consultationsTable-${this.state.age}_${this.props.match.params.patientId}`}
          consultations={this.state.currentPatientData ? this.state.currentPatientData.consultations : null}
          handleSubmit={this.handleChangeConsults} />
      })
    }
    if (this.state.config.eruption) {
      content.push({
        label: polyglot.t('staticText.teethEruption'),
        content: <TeethEruption config={this.state.config.eruption} teethData={this.state.teethData}
          patientBirthDate={this.state.currentPatientBirthDate || null}
          key={`teethEruption-${this.state.age}_${this.props.match.params.patientId}`}
          availableTeeth={this.state.availableTeeth}
          consultationData={this.state.currentPatientData ? this.state.currentPatientData.eruption : null}
          handleChange={this.handleChangeTeethEruption} />
      })
    }
    if (this.state.config.finalConsultation) {
      content.push({
        label: polyglot.t('staticText.finalConsultation'),
        content: <FinalConsultation formConfig={this.state.config.finalConsultation} availableTeeth={this.state.config.availableTeeth} key={`finalConsultation-${this.state.age}_${this.props.match.params.patientId}`}
          teethStatus={this.state.currentPatientTeethStatus}
          handleChange={this.handleChangeFinalConsultation}
          consultationData={this.state.currentPatientData ? this.state.currentPatientData.finalConsultationData : null}
          age={this.state.age} patientKey={this.state.patientKey} />
      })
    }
    return content
  }

  render () {
    return (
      <div className={this.state.loading}>
        {/* <AlertContainer ref={a => { this.msg = a }} {...alertOptions} /> */}
        <div className='container bottom-margin'>
          {this.state.config && this.state.patientKey
            ? <TabsContainer ageKey={`age_${this.state.age}`} defaultActive={this.state.openedTab} content={this.getContentForTabsContainer() || []} />
            : <Loading />
          }
        </div>
      </div>

    )
  }
}

Age.propTypes = {
  data: PropTypes.object,
  setPatientId: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/Age/Age.js